export default __webpack_public_path__ + "static/media/480_dummy2016-personal01-mobile-de.3a0cc717.png";